import type { Company, CompanyStatus, Country } from "@pentacode/core";

export type CompanyFilter = {
    status?: CompanyStatus;
    country?: Country;
};

function matchesStatus(company: Pick<Company, "effectiveStatus">, filter: CompanyFilter) {
    if (!filter.status) return true;

    return company.effectiveStatus === filter.status;
}

function matchesCountry(company: Pick<Company, "country">, filter: CompanyFilter) {
    if (!filter.country) return true;

    return company.country === filter.country;
}

export function applyCompanyFilter<T extends Pick<Company, "effectiveStatus" | "country">>(
    companies: T[],
    filter: CompanyFilter
): T[] {
    return companies.filter((company) => {
        return matchesStatus(company, filter) && matchesCountry(company, filter); // && other filters
    });
}
